import React from 'react';
import PropTypes from 'prop-types';
import { ChromePicker } from 'react-color';

class ColorChooser extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			displayColorPicker: false,
		};
	}

	handleClick = () => {
		console.log('Toggling Color Picker'); // Debugging log
		this.setState((prevState) => ({ displayColorPicker: !prevState.displayColorPicker }));
	};

	handleClose = () => {
		console.log('Closing Color Picker'); // Debugging log
		this.setState({ displayColorPicker: false });
	};

	changeColor = (newColor) => {
		console.log('Selected Color:', newColor.hex); // Debugging log
		this.props.onChange(newColor.hex);
	};

	render() {
		const bgStyle = {
			backgroundColor: this.props.selectedColor,
			border: '1px solid #ddd',
			cursor: 'pointer',
			width: '36px',
			height: '36px',
			borderRadius: '2px',
		};

		return (
			<div className='mb-3' style={{ position: 'relative' }}>
				<div onClick={this.handleClick} style={bgStyle}></div>
				<div>{this.props.title}</div>
				{this.state.displayColorPicker && (
					<div className='color-chooser-popover' style={{ position: 'absolute', zIndex: 2 }}>
						<div
							className='color-chooser-cover'
							style={{
								position: 'fixed',
								top: 0,
								right: 0,
								bottom: 0,
								left: 0,
							}}
							onClick={this.handleClose}
						/>
						<ChromePicker onChange={this.changeColor} color={this.props.selectedColor} />
					</div>
				)}
			</div>
		);
	}
}

ColorChooser.propTypes = {
	name: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	selectedColor: PropTypes.string,
	onChange: PropTypes.func,
};

export default ColorChooser;
